import React from 'react';
import { UploadOutlined } from '@ant-design/icons';
import { error } from '@guuru/react-message';
import { i18n } from '@guuru/translation-web';
import type { UploadFile } from 'antd';
import { UploadButton, Upload } from './style';

const UploadFilesButton = function () {
  return (
    <UploadButton icon={<UploadOutlined />}>
      {i18n.t('chat:::uploadFile')}
    </UploadButton>
  );
};

interface UploadFilesProps {
  currentFiles?: UploadFile[];
  // eslint-disable-next-line no-unused-vars
  setCurrentFiles?: (_: UploadFile[]) => void;
}

const UploadFiles = function ({
  currentFiles = [],
  setCurrentFiles = () => {},
}: UploadFilesProps) {
  const handleChange = (info: { file: UploadFile }) => {
    const { file } = info;
    if (file.status === 'removed') {
      setCurrentFiles(currentFiles.filter((f) => f.uid !== file.uid));
    } else if (file.status === 'uploading') {
      const blob = file?.originFileObj;
      setCurrentFiles([...currentFiles, blob!]);
    } else if (file.status === 'error') {
      error('');
    }
  };

  return (
    <Upload
      accept="image/*,.pdf"
      customRequest={() => {}}
      fileList={currentFiles}
      onChange={handleChange}
      showUploadList={{ showPreviewIcon: false }}
    >
      {currentFiles.length >= 5 ? null : <UploadFilesButton />}
    </Upload>
  );
};

export default UploadFiles;
